<template>
    <div class="">
        <div class="
                    p-channel_sidebar__static_list__item
                    p-channel_sidebar__static_list__item--contain
                    c-virtual_list__item
                ">
            <div
                :class="[
                        'slack-channels-heading',
                        'p-channel_sidebar__section_heading',
                        'p-channel_sidebar__drop_target_indicator',
                        {
                            'p-channel_sidebar__section_heading--collapsed':
                                !is_channels_menu_active,
                        },
                        {
                            'p-channel_sidebar__section_heading--empty':
                                !is_channels_menu_active,
                        },
                        { 'slack-menu-active': is_channels_menu_active },
                    ]"
                @click="is_channels_menu_active = !is_channels_menu_active"
            >
                <span
                    class="
                            slack-channels-expand-container
                            p-channel_sidebar__section_heading_expand_container
                        "
                    aria-hidden="true"
                ><i
                        class="
                                c-icon
                                c-icon--caret-right
                                c-icon--inherit
                                c-icon--inline
                                p-channel_sidebar__section_heading_expand
                            "
                        type="caret-right"
                        aria-hidden="true"
                    ></i></span>
                <div class="
                            slack-heading-label
                            p-channel_sidebar__section_heading_label--clickable
                        ">
                    <span class="
                                p-channel_sidebar__section_heading_label_overflow
                            ">Channels</span>
                </div>
                <div class="
                            p-channel_sidebar__section_heading_right
                            slack-heading-right
                            p-is-pulled-right
                        ">
                    <button
                        class="
                                c-button-unstyled
                                p-channel_sidebar__section_heading_right_item
                                p-channel_sidebar__section_heading_plus
                            "
                        aria-hidden="true"
                        tabindex="-1"
                        aria-haspopup="menu"
                        aria-expanded="false"
                        type="button"
                        @click.stop="is_create_channel_modal_active=true"
                    ></button>
                </div>
            </div>
        </div>
        <div
            class="
                    slack-menu-item slack-channels
                    p-channel_sidebar__static_list__item
                    p-channel_sidebar__static_list__item--contain
                    c-virtual_list__item
                "
            v-for="(item, key) in channels"
            v-show="should_show_channel(item)"
            :key="`channel-${key}`"
        >
            <div
                :class="['p-channel_sidebar__channel', {'p-channel_sidebar__channel--selected': is_channel_selected(item)}]"
                data-qa-channel-sidebar-channel-is-selected="false"
                data-qa-channel-sidebar-channel-is-muted="false"
                data-qa-channel-sidebar-channel-type="channel"
                data-qa-channel-sidebar-is-starred="false"
                data-qa-channel-sidebar-is-you="false"
                @click="handleSlackLabelMenu(item)"
            >
                <i
                    class="
                            c-icon
                            p-channel_sidebar__channel_icon_prefix
                            c-icon--channel-pane-hash
                            c-icon--inherit
                            c-icon--inline
                        "
                    data-qa="sidebar-channel-icon-prefix"
                    type="channel-pane-hash"
                    aria-hidden="true"
                ></i>
                <span
                    dir="auto"
                    class="p-channel_sidebar__name"
                    data-sk="tooltip_parent"
                >{{ item.name }}</span>
            </div>
        </div>
        <o-modal
:can-cancel="['escape', 'outside', 'button']"            :active.sync="is_create_channel_modal_active"
            has-modal-card
            ref="modal"
        >
            <create-channel-modal @onSaved="$emit('onSaved')" />
        </o-modal>
    </div>
</template>

<script>
import CreateChannelModal from './CreateChannelModal'
export default {
    components: {
        CreateChannelModal,
    },
    computed: {
    },
    data() {
        return {
            is_create_channel_modal_active: false,
            is_channels_menu_active: false,
        }
    },
    methods: {
        handleSlackLabelMenu(item) {
            this.$emit('onselected', item)
            this.$router.push({ name: 'slack.channel', params: { id: item.id } })
        },
        is_channel_selected(item) {
            return (this.selected_item && this.selected_item.id === item.id)
        },
        should_show_channel(item) {
            return this.is_channels_menu_active || this.is_channel_selected(item)
        },
    },
    mounted() {
        const modal_ref = this.$refs.modal
        if (!modal_ref) {
            return
        }
        document.body.appendChild(modal_ref.$el)
    },
    props: ['channels', 'selected_item'],
}
</script>
<style lang="sass" scoped>
</style>